module.exports = __webpack_public_path__ + "img/icon-live-active.dc4cf3f.webp";